import React from 'react';
import { DishFirstFoodItemsSegmentFragment } from 'src/gqlReactTypings.generated.d';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';
import { Container, HeroContent } from './styles';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TitleText = styled.h1`
  font-size: 32px; // One-off
  line-height: ${Font.LineHeight.XXL};
  font-weight: ${Font.Weight.BOLD};
  margin: ${Spacing.NONE} ${Spacing.NONE} ${Spacing.HALF};
`;

const Description = styled.h2`
  color: ${Colors.GRAY_DARK_20};
  margin: 0;
  font-size: ${Font.Size.S};
  line-height: ${Font.LineHeight.S};
  font-weight: ${Font.Weight.MEDIUM};
`;

const CountText = styled.div`
  color: ${Colors.GRAY_DARK_20};
  font-size: ${Font.Size.S};
`;

interface IHeroProps {
  className?: string;
  displayName: string;
  subtitle?: string | null;
  total?: number;
}

export const Hero: React.FC<IHeroProps> = ({ className, displayName, subtitle, total }) => (
  <Container className={className}>
    <DishFirstExploreWidthLimit>
      <HeroContent>
        <TitleContainer>
          <TitleText>{displayName}</TitleText>
          {total && <CountText>{total}</CountText>}
        </TitleContainer>
        {subtitle && <Description>{subtitle}</Description>}
      </HeroContent>
    </DishFirstExploreWidthLimit>
  </Container>
);

export interface IProps {
  className?: string;
  segment: DishFirstFoodItemsSegmentFragment;
  /** Overrides segment.content.total */
  total?: number;
}

export const SpecialtyHero: React.FC<IProps> = ({ className, segment, total }) => (
  <Hero
    className={className}
    displayName={segment.displayName}
    subtitle={segment.subtitle}
    total={total ?? segment.content.total}
  />
);
